import React, { useEffect, useState } from 'react';
import {
  Label,
} from 'reactstrap';
import _ from 'lodash';
import { DatetimePicker } from '../../../commons/controls';
import Services from '../services';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import moment from 'moment';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../KedvezmenyTooltips';

const STYLE_LABEL_ROW = {marginTop: '15px', marginBottom: '15px'};

let selected = false;

const HelyiArForm = props => {
  const [penznemList, setPenznemList] = useState([]);
  const [penznem, setPenznem] = useState(null);
  const {
    helyszinAr,
    handleInputChange,
    handleSelectInputChange,
    handleDateInputChange,
  } = props;

  useEffect(() => {
    loadPenznemOptions();
  }, []);

  const loadHelyszinOptions = (input, callback) => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadPenznemOptions = () => {
    Services.listPenznemAktiv((err, res) => {
      if (!err) {
        setPenznemList(res[0]);
        const p = helyszinAr.formPenznem || res[0].find(penznem => penznem.defaultcurrency);
        setPenznem(p);
        handleSelectInputChange(p, 'formPenznem'); 
      }
    });
  }

  const nullOrNullaToEmpty = (value) => {
    return value || value === 0 ? '' + value : ''; 
  }

  const handleDateChange = (e,v,type) => {
    if(selected) {
      selected = false;
      switch (type) {
        case 'formHelyiKezdete':
          if (v) {
            v = moment(v).startOf('day');
          }
          handleDateInputChange(e, v, "formHelyiKezdete");
          break;
        case 'formHelyiVege':
          if (v) {
            v = moment(v).endOf('day');
          }
          handleDateInputChange(e, v, "formHelyiVege");
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'formHelyiKezdete':
          handleDateInputChange(e, v == '' ? v : new Date(e), "formHelyiKezdete");
          break;
        case 'formHelyiVege':
          handleDateInputChange(e, v == '' ? v : new Date(e), "formHelyiVege");
          break;
        default:
          break;
      }
    }
  }

  const renderForm = () => {
    const isLejart = !!helyszinAr.formHelyiVege;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12" style={{paddingTop: '8px'}}>
            <SelectField
              variant='async'
              label='Helyszín:'
              name="formHelyszin"
              id="formHelyszin"
              placeholder="Alapértelmezett..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => {
                handleSelectInputChange(v, 'formHelyszin'); 
              }}
              loadOptions={_.debounce(loadHelyszinOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={helyszinAr.formHelyszin}
              isDisabled={isLejart}
              defaultOptions
              isClearable
            />
          </div>
        </div>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-4">
           <RFField
              label="Alap ár: "
              name={"formHelyiAlapAr"}
              disabled={isLejart}
              value={nullOrNullaToEmpty(helyszinAr.formHelyiAlapAr)}
              onChange={handleInputChange}
              type="number"
              required
              />
          </div>
          <div className="col-md-4">
            <RFField
              label="Csere ár: "
              name={"formHelyiCsereAr"}
              disabled={isLejart}
              value={nullOrNullaToEmpty(helyszinAr.formHelyiCsereAr)}
              onChange={handleInputChange}
              type="number"
            />
          </div>
          <div className="col-md-4">
            <SelectField
              label='Pénznem:'
              name="formPenznem"
              id="formPenznem"
              placeholder="..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => {
                handleSelectInputChange(v, 'formPenznem'); 
                setPenznem(v);
              }}
              options={penznemList}
              getOptionLabel={option => option.azonosito}
              getOptionValue={option => option.id}
              value={penznem}
              isDisabled={isLejart}
              defaultOptions
              isClearable
              required
            />
          </div>
        </div>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-12">
            <DatetimePicker
                label={'Érvényesség kezdete: '}
                id={"formKezdete"}
                name={"formKezdete"}
                value={(helyszinAr.formHelyiKezdete && new Date(helyszinAr.formHelyiKezdete))}
                onChange={(e,v) => handleDateChange(e, v, "formHelyiKezdete")}
                onSelect={() => { selected = true }}
                containerClassName="organw-date-time"
                time
                disabled={isLejart}
                // format="YYYY-MM-DD HH:mm:ss"
                messages={{ dateButton: "dátum", timeButton: "idő" }}
                timePrecision="seconds"
                required
              />
          </div>
        </div>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-12">
            <DatetimePicker
              label={'Érvényesség vége: '}
              tooltip={<CustomTooltip text={getTooltip('kartyatipusarervenyessegvege')} id='kartyatipusarervenyessegvegeTT' />}
              id={"formVege"}
              name={"formVege"}
              value={helyszinAr.formHelyiVege && new Date(helyszinAr.formHelyiVege)}
              onChange={(e,v) => handleDateChange(e, v, "formHelyiVege")}
              onSelect={() => { selected = true }}
              containerClassName="organw-date-time"
              disabled
              time
              // format="YYYY-MM-DD HH:mm:ss"
              messages={{ dateButton: "dátum", timeButton: "idő" }}
              timePrecision="seconds"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (renderForm());
}

export default HelyiArForm;